import { useEffect, useState } from 'react';
import './GeneratedImage.scss';
import useDynamicState from '../../utils/useStateDynamic';
import { Button, Icon, Loader, Popup } from 'semantic-ui-react';
import api from '../../utils/api';

enum GeneratedState{
    NotStarted,
    Generating,
    Complited,
    Error,
    EmptyPromt,
}

interface GeneratedImageProps{
    promt:string
    imageId?:string
    width?:number
    height?:number
    onGetId?:(promt:string, id:string)=>void
}

function GeneratedImage({promt, imageId, width=100, height=100, onGetId}:GeneratedImageProps) {
    const [state, stateRef, setState] = useDynamicState<GeneratedState>(GeneratedState.Generating);
    const [id, idRef, setId] = useDynamicState<string|null>(null);
    const [intervalState, setIntervalState] = useState<NodeJS.Timeout|undefined>();
    const generate = (promt:string) => {
        api.generateImage(promt).then(resp => {
            setId(resp.id);
            if(onGetId !== undefined)
                onGetId(promt, resp.id);
            setState(GeneratedState.Generating);
        });
    };
    useEffect(() => {
        if((promt === '' || promt === undefined || promt === null) && (imageId === undefined || imageId == null)){
            setState(GeneratedState.EmptyPromt);
            return;
        }
        if(imageId === undefined || imageId == null){
            generate(promt!);
        }else{
            setId(imageId!);
        }
        if(intervalState === undefined) {
            const interval = setInterval(() => {
                // debugger
                if(stateRef.current === GeneratedState.Error) {
                    return
                }
                if(stateRef.current === GeneratedState.Generating && idRef.current != undefined){
                    api.getImageState(idRef.current).then(imageState => {
                        if(imageState.status === 'done'){
                            setState(GeneratedState.Complited);
                        }
                        if(imageState.status === 'error'){
                            setState(GeneratedState.Error);
                        }
                    })
                }
            }, 1000);
            setIntervalState(interval);
            return () => clearInterval(intervalState);    
        }
    }, [promt, imageId]);
    return <div className='generated-image' style={{width, height}}>
        {(()=>{
            switch(state){
                case GeneratedState.NotStarted:
                    return <div></div>;
                case GeneratedState.Generating:
                    return <Loader active inline />;
                case GeneratedState.Complited:
                    return <img alt={promt} src={api.getImageUrl(id!)} />;
                case GeneratedState.Error:
                    return <div>Error</div>;
                case GeneratedState.EmptyPromt:
                    return <div>Empty promt</div>;
            }
        })()}
        {state === GeneratedState.Complited || state === GeneratedState.Error  ? <Popup basic on='click' closeOnPortalMouseLeave trigger={<div onClick={e => {e.stopPropagation(); e.preventDefault();}} className='open-context-menu-btn'><Icon size='small' name='ellipsis vertical' /></div>} content={
            <div className='message-actions-container'>
                <p>{promt}</p>
                <Button basic fluid size='tiny' onClick={e => {e.stopPropagation(); e.preventDefault(); generate(promt!);}}><Icon name='refresh' /> Перегенерировать</Button>
            </div>
            } /> : ''}
    </div>;
}

export default GeneratedImage;